// Shared constants for landing page components
// Centralizes animation timings, thresholds, and other configuration values

// HeroSection parallax effect constants
export const PARALLAX = {
  X_SPEED: 0.4,        // Horizontal oscillation speed
  Y_SPEED: 0.25,       // Vertical oscillation speed
  X_AMPLITUDE: 1.0,    // Horizontal movement range
  Y_AMPLITUDE: 0.3,    // Vertical movement range
  SMOOTHING: 0.02,     // Interpolation factor for smooth movement
  INTENSITY: 1.5,      // Depth effect multiplier
  IMAGE_CYCLE_MS: 10000, // Time between image transitions
  FADE_DURATION_MS: 800, // Image crossfade duration
} as const

// ChatboxPrompt typing animation constants
export const TYPING = {
  CHAR_DELAY_MS: 50,       // Delay between typing each character
  HOLD_DELAY_MS: 3000,     // Time to show completed text before cycling
  FLY_OFF_DURATION_MS: 500, // Duration of fly-off animation
  RESET_DELAY_MS: 300,     // Pause before typing next query
  INITIAL_DELAY_MS: 1000,  // Initial delay before typing starts
  BLUR_RESUME_DELAY_MS: 1000, // Delay before resuming after blur
} as const

// GridSection scroll and animation constants
export const GRID = {
  SCROLL_EASE: 0.06,   // Scroll interpolation factor
  DELTA_EASE: 0.04,    // Delta/mouse interpolation factor
  MOUSE_PARALLAX: 0.6, // Mouse-based parallax intensity
  SCROLL_MULTIPLIER: 5, // Scroll delta multiplier
  IMG_SCALE_BASE: 1.2, // Base image scale
  IMG_SCALE_PRESS: 0.2, // Additional scale when pressed
  IMG_TRANSLATE: 10,   // Image translation percentage on mouse move
  INTRO_DURATION: 2,   // Intro animation duration in seconds
  INTRO_STAGGER: 0.05, // Stagger between intro items
} as const

// Sample queries for ChatboxPrompt
export const SAMPLE_QUERIES = [
  'Luxury hotels for families in Kyoto, Japan',
  'Visiting the Empire State Building on a weekday',
  'Best vintage stores in Brooklyn',
  'Reserve a tour for the Golden Temple in Kyoto',
  'Weekend itinerary for exploring New York City',
] as const
